import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real9 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/aldi/aldi5.jpg"),
        thumbnail: require("../../assets/images/aldi/aldi5.jpg")
      },
      {
        original: require("../../assets/images/aldi/aldi6.jpg"),
        thumbnail: require("../../assets/images/aldi/aldi6.jpg")
      },
      {
        original: require("../../assets/images/aldi/aldi7.jpg"),
        thumbnail: require("../../assets/images/aldi/aldi7.jpg")
      },
      {
        original: require("../../assets/images/aldi/aldi8.jpg"),
        thumbnail: require("../../assets/images/aldi/aldi8.jpg")
      },
      {
        original: require("../../assets/images/aldi/aldi9.jpg"),
        thumbnail: require("../../assets/images/aldi/aldi9.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Clôture pour la protection d'un groupe froid</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real9;